import { RgbColor } from "./RgbColor"



export var data = {
    RgbColor
};